<template>
  <div class="behaviour-select-students-fieldset">
    <p
      class="behaviour-select-students-fieldset__legend text-uppercase small text-muted mb-3"
      role="heading"
      aria-level="3"
    >
      {{ $t("behaviour_manage.select_students_fieldset") }}
    </p>
    <Label required :label-id="labelId" :html-for="inputId">
      {{ $t("behaviour_manage.select_students_label") }}
    </Label>
    <BehaviourStudentLazySelect
      :model-value="modelValue"
      class="w-100"
      multiple
      hide-floating-label
      :labelled-by="labelId"
      :input-id="inputId"
      :accessible-label="$t('behaviour_manage.select_students_label')"
      :placeholder="$t('behaviour_manage.select_students_placeholder')"
      :invalid-feedback="invalidFeedback"
      append-dropdown-to-body
      append-dropdown-fixed-position
      :data-testid="dataTestid"
      @update:model-value="$emit('update:modelValue', $event)"
      @changed="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
import BehaviourStudentLazySelect from "@/v3components/Behaviour/BehaviourStudentLazySelect.vue"
import Label from "@/v3components/shared/Form/Label.vue"

export default {
  name: "BehaviourSelectStudentsFieldset",
  components: {
    BehaviourStudentLazySelect,
    Label
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    invalidFeedback: {
      type: String,
      default: ""
    },
    labelId: {
      type: String,
      default: "behaviour-select-students-lbl"
    },
    inputId: {
      type: String,
      default: "behaviour-select-students-input"
    },
    dataTestid: {
      type: String,
      default: "behaviour-select-students"
    }
  },
  emits: ["update:modelValue"]
}
</script>
